import { ChangeSource } from '@modules/projects/shared/enums/change-source.enum';
import { Component, OnInit } from '@angular/core';
import { TaskSidenavService } from '@shared/modules/task-sidenav/services/task-sidenav.service';
import { StorageService } from '@core/services/storage.service';
import { ProjectChangesSettlementStatus } from '@modules/projects/shared/enums/project-change-settlement-status.enum';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'task-changes-summary',
  templateUrl: './task-changes-summary.component.html',
  styleUrls: ['./task-changes-summary.component.scss']
})
export class TaskChangesSummaryComponent implements OnInit {
  ChangeSource = ChangeSource;
  protocolPreviewPermission: boolean = false;

  settlementsItems = [
    { name: 'Projects.ProjectSettlement.null', value: ProjectChangesSettlementStatus.CHANGE_SETTLEMENT_NONE },
    {
      name: 'Projects.ProjectSettlement.unsettled',
      value: ProjectChangesSettlementStatus.CHANGE_SETTLEMENT_NOT_SETTLED
    },
    {
      name: 'Projects.ProjectSettlement.settled',
      value: ProjectChangesSettlementStatus.CHANGE_SETTLEMENT_SETTLED
    }
  ].map((i) => {
    i.name = this.t.instant(i.name);
    return i;
  });

  constructor(
    public service: TaskSidenavService,
    public store: StorageService,
    private t: TranslateService
  ) {}

  ngOnInit(): void {}
}
